import { useState } from "react";

const RandomByteGenerator = () => {

  const [byte, setByte] = useState("00000000");

  document.addEventListener("keydown", function(event){
    if (event.key == "Enter"){
      setByte(`${Math.floor(Math.random() * 2)}${Math.floor(Math.random() * 2)}${Math.floor(Math.random() * 2)}${Math.floor(Math.random() * 2)}${Math.floor(Math.random() * 2)}${Math.floor(Math.random() * 2)}${Math.floor(Math.random() * 2)}${Math.floor(Math.random() * 2)}`);
    }
  });

  return (

    <section className="articles">
      
      <article className="web-toy">
        <div className="centered">
          <h3>Random Byte Generator</h3>
          <p>Press enter for a new byte</p>
          <h1>{ byte }</h1>
        </div>
      </article>

    </section>

  );
}

export default RandomByteGenerator;